import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { qualityKeys } from '@/shared/lib/query/queryKeys';

import { type DataZoneRowCountApiParams, getDataZoneRowCount } from '@/entities/quality/api/getDataZoneRowCount';

export const useDataZoneRowCountQuery = (params: DataZoneRowCountApiParams) => {
  return useQueryWithBoundary({
    queryKey: qualityKeys.dataZoneRowCount(params),
    queryFn: () => getDataZoneRowCount(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
